import React from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import NRHighlightedText from '../../../NRHighlightedText/NRHighlightedText';
import { getWeightedCategory, getWeightedColor, getWeightedColorAlt, isNumber } from '../../../../utils/utils';
import LinearProgress from '@mui/material/LinearProgress';
import makeStyles from '@mui/styles/makeStyles';
import { CONSTANTS } from '../../../../constants/constants';
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { NRHandleEmptyCellValue } from '../../CellComponent/CellComponent';
import customTheme from '../../../customTheme';
import { useTheme } from '@mui/material/styles';
import CustomProgressBarStyles from './CustomProgressBar.styles';
import OverallRiskFormatterStyles from './OverallRiskFormatter.styles';
import { withCustomParams } from '../../../NRReactGrid/withCustomParams';
const customProgressBarStyles = makeStyles(CustomProgressBarStyles);
const useRiskFormatterStyles = makeStyles(OverallRiskFormatterStyles);

const CustomProgressBar = () => {
  const classes = customProgressBarStyles();
  return <LinearProgress classes={{ root: classes.root, colorPrimary: classes.colorPrimary, bar: classes.bar }} />;
};

export const OverallRiskFormatter = ({ value, row, isEditing, assetGroupId }) => {
  const { GO_TO_REPORT_TOOLTIP } = CONSTANTS.TABLE.ASSETS;
  const classes = useRiskFormatterStyles();
  const theme = useTheme();
  const weightedCategory = getWeightedCategory(value);
  const weightedColor = getWeightedColor(!isNumber(value) ? 0 : value, theme);
  const weightedColorAlt = getWeightedColorAlt(!isNumber(value) ? 0 : value, theme);
  const statusValue = row?.status;
  const location = useLocation();
  const pathname = location.pathname;

  return (
    <>
      {(statusValue === CONSTANTS.TABLE.ASSETS.STATUS.COMPLETED || statusValue === undefined) && (
        <Link
          to={`${pathname}/${!!pathname.includes('groups') ? assetGroupId + '/' : ''}${row?.id}`}
          className={clsx(classes.link, { [classes.disabled]: isEditing })}
        >
          <NRHighlightedText
            style={{ cursor: 'pointer' }}
            color={weightedColor}
            colorAlt={weightedColorAlt}
            backgroundColor={weightedColor}
            textAlphaValue={!isNumber(value) ? 0.56 : 1}
            highlightAll={true}
            text={`${!!value ? value + ' - ' : ''}${weightedCategory}`}
            alphaValue={0.15}
            showBorder={true}
            minWidth={'120px'}
            justifyContent={'center'}
            fontSize={12}
            lineHeight={14}
            tooltipContent={GO_TO_REPORT_TOOLTIP}
          />
        </Link>
      )}
      {statusValue === CONSTANTS.TABLE.ASSETS.STATUS.IN_PROGRESS && <CustomProgressBar />}
      {statusValue === CONSTANTS.TABLE.ASSETS.STATUS.FAILED && <NRHandleEmptyCellValue />}
    </>
  );
};
export const OverallRiskProvider = ({ extraParams, ...props }) => {
  const CustomOverallRiskFormatter = withCustomParams(OverallRiskFormatter, extraParams);
  return <DataTypeProvider formatterComponent={CustomOverallRiskFormatter} {...props} />;
};
